export default __webpack_public_path__ + "static/media/notification.bb610050.mp3";